import type { ReactElement, ReactNode } from 'react'
import type { ParseKeys } from 'i18next'
import { useTranslation } from 'next-i18next/pages'
import Head from 'next/dist/shared/lib/head'
import { FAVICON_LINK_KEYS } from 'shared/constants'
import type { DomainAssetsInterface } from 'shared/types/domain'
import Header from 'modules/header'
import { useBrand } from 'modules/white-label/contexts/brand-context'

export interface ProfilePageLayoutProps {
  titleKey?: ParseKeys
  domainAssets?: DomainAssetsInterface
}

const ProfilePageLayout = ({
  titleKey = 'profile.user_settings.profile.title',
  children,
  domainAssets,
}: React.PropsWithChildren<ProfilePageLayoutProps>): ReactNode => {
  const { t } = useTranslation()

  const { brand } = useBrand()

  return (
    <div className="flex min-h-dvh flex-col bg-bg-page font-inter">
      <Head>
        <title>{t(titleKey)}</title>
        {domainAssets?.faviconUrl && (
          <link key={FAVICON_LINK_KEYS.icon} rel="icon" href={domainAssets.faviconUrl} />
        )}
      </Head>
      <Header
        logoSrc={domainAssets?.logoUrl || brand.logo?.path}
        headerContainerClassName="mx-auto max-w-(--breakpoint-2xl) px-4 tablet:px-6 lg:px-14"
      />
      {children}
    </div>
  )
}

export const getProfilePageLayout = (
  page: ReactNode,
  props?: ProfilePageLayoutProps,
): ReactElement => <ProfilePageLayout {...props}>{page}</ProfilePageLayout>
